import axios from 'axios'
import { Message } from 'element-ui'
import qs from 'qs'
import router from "@/router";

// const baseUrl = 'http://60.190.114.207/yichengshi'
let baseUrl = 'https://api.yichengshi.cn'
let wfBaseUrl = 'https://www.163.gg/wangfu'
// const pushBasePath = "http://192.168.1.27:8092/push";
let pushBasePath = 'https://mdc.zuwo.la/push'
if (!!~location.href.indexOf('192.168') || !!~location.href.indexOf('localhost')) {
    // baseUrl = 'https://api.yichengshi.cn'
    baseUrl = 'http://192.168.110.140:8084'
    // baseUrl = 'http://192.168.110.201:8084'
    wfBaseUrl = localStorage.wfBaseUrl || 'http://192.168.110.201:8084/wangfu'
    // baseUrl = localStorage.baseUrl || 'http://192.168.110.201:8084'
    pushBasePath = 'https://mdc.zuwo.la/push'
}

const instance = axios.create({
    baseURL: baseUrl,
    timeout: 60000,
    withCredentials: false,
})

instance.interceptors.request.use((config) => {
    try {
        if (!!~config.url.indexOf("edcmanageapi/Goods_importGoodsNum")) {
            config.timeout = 60000
        }
        if (!!~config.url.indexOf("miniProgram/MiniAppAuth_wxMiniAppApplyPrivacy")) {
            // let headerOpts = {
            //     "Content-Type": "application/json"
            // };
            // config.headers = Object.assign({}, config.headers, headerOpts);
            // config.traditional = true;
            config.paramsSerializer = (params) => {
                return qs.stringify(params, {
                    indices: true
                })
            }
        }
        let sessionId = localStorage.getItem('sessionId')
        let userId = localStorage.getItem('userId')
        let shopStoreId = localStorage.getItem('shopStoreId')
        let param = qs.parse(config.data)
        param.pfAppType = 30;
        if (userId) {
            param.userId = userId
            param.sessionId = sessionId
            if (param.shopStoreId !== "" && !param.shopStoreId) {
                param.shopStoreId = shopStoreId
            }
        }
        config.data = qs.stringify(param)
    } catch (e) {
        throw e
    }
    return config
})

instance.interceptors.response.use(
    (response) => {
        // 在这里你可以判断后台返回数据携带的请求码
        if (response.data.code == 1) {
            return response.data
        } else {
            if (response.data.code == 0) {
                if (response.data.msg.length == 0) {
                    return
                }
                // Message({
                //     showClose: true,
                //     message: response.data.msg,
                //     type: 'error'
                // })
            }
            if (response.data.code == 2) {
                localStorage.removeItem('sessionId')
                localStorage.removeItem('userId')
                localStorage.removeItem("userType");
                localStorage.removeItem("shopStoreId");
                // location.replace('/#/login')
                if (window.ignoreList.some(r => location.hash.includes(r))) return;
                router.push({
                    path: "/login",
                });

            }

            return response.data
        }
    },
    (error) => {
        console.log('err', error)
        return Promise.reject(error)
    }
)

export default {
    baseUrl,
    get(
        url,
        param,
        resParams = {
            notify: true,
        }
    ) {
        return new Promise((resolve, reject) => {
            instance
                .get(url, {
                    params: param,
                    resParams: resParams,
                })
                .then((res) => {
                    resolve(res)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    post(
        url,
        param,
        resParams = {
            notify: true,
        }
    ) {
        return new Promise((resolve, reject) => {
            instance
                .post(url, qs.stringify(param), {
                    resParams: resParams,
                })
                .then((res) => {
                    resolve(res)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    customPost(
        url,
        param,
        resParams = {
            notify: true,
        },
        baseurl = baseUrl
    ) {
        return new Promise((resolve, reject) => {
            axios
                .create({
                    baseURL: baseurl,
                    timeout: 60000,
                    withCredentials: false,
                    onUploadProgress: function (progressEvent) {
                        console.log(progressEvent, "progressEvent")
                        let complete = (progressEvent.loaded / progressEvent.total).toFixed(2) * 100;
                        console.log(complete, "complete")
                        return complete
                    },
                })
                .post(url, param, {
                    resParams: resParams,
                })
                .then((res) => {
                    resolve(res.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    wfPost(
        url,
        param,
        resParams = {
            notify: true,
        }
    ) {
        return new Promise((resolve, reject) => {
            axios
                .create({
                    baseURL: wfBaseUrl,
                    timeout: 60000,
                    withCredentials: false,
                })
                .post(url, param, {
                    resParams: resParams,
                })
                .then((res) => {
                    resolve(res.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    pushPost(url, param, baseurl = pushBasePath) {
        return new Promise((resolve, reject) => {
            axios
                .create({
                    baseURL: baseurl,
                    timeout: 60000,
                    withCredentials: false,
                })
                .post(url, param, {
                    resParams: resParams,
                })
                .then((res) => {
                    resolve(res.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
    testGet(
        url,
        param,
        resParams = {
            notify: true,
        }) {
        return new Promise((resolve, reject) => {
            axios
                .create({
                    baseURL: "http://exam.wzlive.club/",
                    timeout: 60000,
                    withCredentials: false,
                })
                .get(url, {
                    params: param,
                    resParams: resParams,
                })
                .then((res) => {
                    resolve(res.data)
                })
                .catch((err) => {
                    reject(err)
                })
        })
    },
}